import { SelectionModel } from '@actual-dev/pdf-signer/lib/Models/selectionModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { CertificateSelectionDialogComponent } from '@common/modals/certificate-selection/certificate-selection.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { XmlSigner } from 'xml-signer';
import { DialogService } from './dialog.service';
import { ToastyService } from '@cime/ngx-toasty';

@Injectable()
export class PdfSignatureService {
    signer = new XmlSigner();
    private modalRef: NgbModalRef;

    constructor(
        private http: HttpClient,
        private modalService: NgbModal,
        protected toastyService: ToastyService,
        private translateService: TranslateService,
        private dialogService: DialogService
    ) { }

    signPdfFile(signPdfDto: any): Observable<any> {
        const headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Origin', '*');
        // return this.http.post<any>('http://localhost:999/Signature/SignPdf', signPdfDto, { headers: headers, responseType: 'arrayBuffer' as 'json' });
        return this.http.post<any>('http://localhost:999/Signature/SignPdf', signPdfDto, { headers: headers });
    }

    async selectCertificate() {
        try {
            await this.signer.start();
            const certificates = await this.signer.getCertificates({
                // keyUsages: [CertificateKeyUsage.DigitalSignature],
                issuerName: '',
            });

            if (!certificates.length) {
                this.toastyService.error(this.translateService.instant('Missing certificate'));
                return null;
            }

            this.modalRef = this.modalService.open(CertificateSelectionDialogComponent, {
                backdrop: 'static',
                size: 'xl',
                keyboard: true,
                centered: true,
            });

            this.modalRef.componentInstance.availableCertificates = certificates;

            return this.modalRef.result;
        } catch (error) {

            try {
                // if XmlSigner is still loading (usually load takes more time after first install or first run) try another start() and only if this fails show popup dialog for XmlSigner component .msi download
                await this.signer.start();
                const certificates = await this.signer.getCertificates({
                    // keyUsages: [CertificateKeyUsage.DigitalSignature],
                    issuerName: '',
                });

                if (!certificates.length) {
                    this.toastyService.error(this.translateService.instant('Missing certificate'));
                    return null;
                }

                this.modalRef = this.modalService.open(CertificateSelectionDialogComponent, {
                    backdrop: 'static',
                    size: 'xl',
                    keyboard: true,
                    centered: true,
                });

                this.modalRef.componentInstance.availableCertificates = certificates;

                return this.modalRef.result;
            } catch (error) {
                const confirmDialogResult = await this.dialogService.confirm(
                    this.translateService.instant('XML SIGNER'),
                    this.translateService.instant('Are you sure you want to download XML SIGN component?')
                );

                if (!confirmDialogResult) return;

                const link = document.createElement('a');
                this.toastyService.error(this.translateService.instant(error.toString()));
                alert(error);

                link.setAttribute('href', '../assets/files/XmlSigner-1.0.0.0-Release-x64.msi');
                (link as any).download = 'XmlSigner-1.0.0.0-Release-x64.msi';
                link.click();

                return null;
            }


        }
    }

    async signPdfImplementation(pdf, selectedCertificate, appearance: SelectionModel) {
        try {
            const result = await this.signer.signPdf({
                pdf: pdf,
                signingCertificateSerialNumber: selectedCertificate,
                signatureAppearance: {
                    page: appearance.page,
                    positionBottom: appearance.positionBottom,
                    positionLeft: appearance.positionLeft,
                    width: appearance.width,
                    height: appearance.height,
                    dateFormat: 'dd/MM/yyyy HH:mm:ss'
                }
            });

            return result.signedPdf;
        } catch (error) {

            if (isDevMode()) {
                console.error(error);
            }
            return null;
        }
    }
}
